function r(r, e) {
  return function (n) {
    var t = arguments.length;
    if (e && (n = Object(n)), t < 2 || null == n) return n;
    for (var a = 1; a < t; a++) for (var u = arguments[a], f = r(u), o = f.length, i = 0; i < o; i++) {
      var l = f[i];
      e && void 0 !== n[l] || (n[l] = u[l]);
    }
    return n;
  };
}
export { r as default };